import React from 'react';

import styles from './section.scss';

interface Props {
  children: React.ReactNode | React.ReactNode[] | null;
  className?: string;
}

export const Section: React.FC<Props> = ({ children, className = '' }) => (
  <>
    <div className={`${styles.container} ${className}`}>{children}</div>
  </>
);
